<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">請求処理</div>
    <div v-if="isOpen" class="dropdown-menu">
      <router-link to="/seikyuInfo" class="dropdown-item" @click="closeDropdown"
        >請求情報</router-link
      >
      <router-link to="/kokuhorenDenso" class="dropdown-item" @click="closeDropdown"
        >国保連伝送データ(介護、予防)</router-link
      >

      <router-link
        to="/sogojigyokokuhorenDenso"
        class="dropdown-item"
        @click="closeDropdown"
        >国保連伝送データ(総合事業)</router-link
      >

      <router-link
        to="/kaigoKyuhuhiSeikyusyo"
        class="dropdown-item"
        @click="closeDropdown"
        >介護給付費請求書</router-link
      >

      <router-link
        to="/sogojigyouhiSeikyusyo"
        class="dropdown-item"
        @click="closeDropdown"
        >総合事業費請求書</router-link
      >

      <router-link
        to="/kaigoKyuhuhiMeisaisho"
        class="dropdown-item"
        @click="closeDropdown"
        >介護給付費明細書</router-link
      >

      <router-link to="/yoboKyuhuhiMeisaisho" class="dropdown-item" @click="closeDropdown"
        >予防給付費明細書</router-link
      >

      <router-link to="/sogoJigyoMeisaisho" class="dropdown-item" @click="closeDropdown"
        >総合事業費明細書</router-link
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps } from "vue";
import { RouterLink } from "vue-router";
import CompanyService from "../Js/CompanyService";
const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu4: Boolean,
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
  isOpen.value = false;
};

watch(
  () => props.isOpenMenu4,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item {
  padding: 8px;
  display: block;
  color: black;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
